import React from "react";
import { barShares } from "./lineupModel";
import "./football-app.css";

const fmt = (row, v) => {
  if (v === null || v === undefined) return "—";
  if (row.digits !== undefined) return Number(v).toFixed(row.digits);
  return row.pct ? `${v}%` : String(v);
};

/** Possession pill: only rendered when both sides are recorded. */
export function PossessionBar({ possession }) {
  if (!possession) return null;
  const total = possession.home + possession.away || 1;
  const home = (possession.home / total) * 100;
  return (
    <div role="img" aria-label={`Possession ${possession.home}% to ${possession.away}%`}>
      <div className="fa-sub" style={{ textAlign: "center", marginBottom: 4 }}>Ball possession</div>
      <div className="fa-possession">
        <span className="h" style={{ width: `${home}%` }}>{possession.home}%</span>
        <span className="a" style={{ width: `${100 - home}%` }}>{possession.away}%</span>
      </div>
    </div>
  );
}

/** Stat rows with a leading pill and a thin share bar. Missing values render as an em dash. */
export default function StatComparison({ rows, homeName, awayName }) {
  if (!rows?.length) return null;
  return (
    <div>
      <div className="fa-legend" aria-hidden="true"><span>{homeName}</span><span>{awayName}</span></div>
      {rows.map((row) => {
        const shares = barShares(row.home, row.away);
        const leadHome = row.home !== null && row.away !== null && row.home > row.away;
        const leadAway = row.home !== null && row.away !== null && row.away > row.home;
        return (
          <div className="fa-stat" key={row.key} role="group" aria-label={`${row.label}: ${homeName} ${fmt(row, row.home)}, ${awayName} ${fmt(row, row.away)}`}>
            <span className={`v ${leadHome ? "lead" : ""}`}>{fmt(row, row.home)}</span>
            <span className="l">{row.label}</span>
            <span className={`v ${leadAway ? "lead away" : ""}`}>{fmt(row, row.away)}</span>
            {shares && !shares.empty && (
              <div className="fa-statbar" aria-hidden="true">
                <i style={{ width: `${shares.home * 100}%` }} />
                <i style={{ width: `${shares.away * 100}%` }} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
